export const styles = {
  root: {
    height: '100%',
    color: '#011533',
    '@media screen and (max-width:768px)': {
      minHeight: '90vh',
    },
  },
  main: {
    marginTop: '20px',
    '@media screen and (max-width:768px)': {
      display: 'flex',
      flexDirection: 'column',
      marginTop: 0,
      minHeight: '90vh',
    },
  },
  title: {
    fontSize: '32px',
    fontWeight: 800,
    marginRight: '60px',
    '@media screen and (max-width:768px)': {
      padding: '10px 0 20px',
    },
  },
  titleWrap: {
    display: 'flex',
    alignItems: 'center',
  },
  subtitle: {
    padding: '10px 20px',
    background: '#FFE3E8',
    borderRadius: '4px',
    width: 'max-content',
    margin: '6px 0px 30px',
    fontSize: '16px',
    '@media screen and (max-width:768px)': {
      width: '100%',
      margin: '0px 0 18px',
    },
  },
  reasons: {
    fontSize: '18px',
    fontWeight: 700,
    marginBottom: '12px',
    '@media screen and (max-width:768px)': {
      marginBottom: '7px',
    },
  },
  text: {
    maxWidth: '560px',
    fontSize: '16px',
    marginBottom: '32px',
    '@media screen and (max-width:768px)': {
      marginBottom: '20px',
      fontSize: '18px',
    },
  },
  loadingWrapper: {
    marginTop: '250px',
  },
  wrapperButton: {
    marginBottom: '30px',
    '@media screen and (max-width:768px)': {
      marginTop: 'auto',
      width: '100%',
      selfAlign: 'center',
    },
  },
}
